import { PostgrestError } from "@supabase/supabase-js";
import { updateAccountProfile as updateAccountProfileAction } from "store/accountProfileSlice";
import store from "store/store";

import { supabase } from "apis/supabaseClient";

import { getAccountProfile } from "./accountProfile";

export type Location = {
  name: string;
  lat?: number;
  lng?: number;
};

export const fetchLocationByPlaceId = async (
  placeId: string
): Promise<Location> => {
  const res = await fetch(
    `/googlemaps/proxy/maps/api/place/details/json?fields=geometry,formatted_address&place_id=${placeId}`
  );
  const body = await res.json();
  if (body) {
    const {
      formatted_address: name,
      geometry: {
        location: { lat, lng },
      },
    } = body.result;
    return { name, lat, lng };
  } else {
    throw Error;
  }
};

export const fetchLocationPredictions = async (
  searchText: string
): Promise<
  {
    name: string;
    label: string;
  }[]
> => {
  const res = await fetch(
    `/googlemaps/proxy/maps/api/place/autocomplete/json?input=${searchText}&types=%28regions%29`
  );
  const body = await res.json();
  return (
    body?.predictions.map(
      (prediction: { place_id: string; description: string }) => ({
        name: prediction.place_id,
        label: prediction.description,
      })
    ) || []
  );
};

export const upsertLocation = async (
  userId: string,
  location: Location
): Promise<{ error: PostgrestError | null }> => {
  const { error } = await supabase.from("user_location").upsert({
    name: location.name,
    lat: location.lat || null,
    lng: location.lng || null,
    user_id: userId,
  });

  store.dispatch(updateAccountProfileAction(await getAccountProfile()));

  return { error };
};
